import { getSmsMetricsChart } from '@/services/dashboard-service/dashboard.service';
import { SmsMetricsChartParams } from '@/services/dashboard-service/dashboard.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export const useSmsMetricsChart = (params: SmsMetricsChartParams) => {
  const {
    data: smsMetricsChartData,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.SMS_METRICS_CHART(params),
    queryFn: () => getSmsMetricsChart(params),
    enabled: !!params.chart_params,
  });
  return { smsMetricsChartData, error, isLoading, refetch };
};
